module.exports = __webpack_public_path__ + "img/apple-pay.9194740a.png";